import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import { PsrVulnerability } from "./psrVulnerability"
import { IPsrVulnerability } from "@/models/psr/psr.types"
import { Vulnerability } from "@/api/backofficeRest/generated/model"

export type IPsrVulnerabilityRaw = Vulnerability

export const PsrVulnerabilityParser: IParser<
  IPsrVulnerability,
  IPsrVulnerabilityRaw
> = {
  toDomain: (data: IPsrVulnerabilityRaw) => {
    try {
      return new PsrVulnerability(
        data.id,
        data.label,
        data.description,
        data.requiresEndDate,
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
